var actionTypes = require('../../../actionTypes.js');

module.exports.createAction = (payload)=> (
            {
                type: actionTypes.mainBarOption,
                payload: payload
            }
           )

module.exports.changeState = (previousState, payload)=> Object.assign({}, previousState, {mainBarOptions: payload})